import React from 'react';
import { deleteSelectedSchoolFromSchools } from '../../../redux/modules/addSchool/addSchool.module';
import { DELETE_SCHOOL_MODAL } from '../../../settings/settings';
import { Button, ButtonType } from '../../Shared/Button';
import './DeleteSchoolModal.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateSelectedSchool,
  getSelectedSchool,
} from '../../../redux/modules/schoolSelection';

const DeleteSchoolModal = ({ closeModal }) => {
  const dispatch = useDispatch();

  const selectedSchool = useSelector(getSelectedSchool);

  const handleDeleteSchool = () => {
    dispatch(deleteSelectedSchoolFromSchools(selectedSchool?.id));
    dispatch(updateSelectedSchool(null));
    closeModal(DELETE_SCHOOL_MODAL);
  };

  return (
    <div className="delete-school-modal">
      <h3>Are you sure you want to delete this educational institution?</h3>

      <div className="delete-school-cancel-buttons">
        <Button
          applyBranding
          buttonType={ButtonType.SECONDARY_SLIM}
          className="delete-school-cancel-btn"
          id="delete-school-cancel-btn"
          data-testid="delete-school-cancel-btn"
          onClick={() => closeModal(DELETE_SCHOOL_MODAL)}
        >
          Cancel
        </Button>
        <Button
          applyBranding
          buttonType={ButtonType.PRIMARY}
          className="delete-school-submit-btn"
          id="delete-school-submit-btn"
          data-testid="delete-school-submit-btn"
          onClick={handleDeleteSchool}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

export default DeleteSchoolModal;
